import styled from "styled-components";

const Price = styled.div`
    max-width: 296px;
    margin-bottom: 8px;
    color: #333;
    font-size: 22px;
    font-weight: 400;
    line-height: 1.3;
    .promo-price {
        & + span {
            text-decoration: line-through;
            color: #666;
            font-size: 18px;
        }
    }
`;
export default Price;
